import { useState, useCallback, useMemo } from "react";

/**
 * useFormValidation Hook
 * Validates My User form fields
 * Memoized validation logic
 * 
 * @returns {Object} Validation state and methods
 */
export const useFormValidation = () => {
  const [formValidation, setFormValidation] = useState({});

  // Memoized validation checker
  const checkValidation = useCallback((values) => {
    const errors = {};
    
    if (!values.userName) {
      errors.userName = "Please enter userName";
    }

    if (!values.mobileNumber) {
      errors.mobileNumber = "Please enter your mobile number";
    } else if (values.mobileNumber?.length !== 10) {
      errors.mobileNumber = "Please enter the valid mobile number";
    }
    
    if (!values.territory) {
      errors.territory = "Please select the territory";
    }
    
    if (!values.category) {
      errors.category = "Please select the category";
    }
    
    if (!values.Observation) {
      errors.Observation = "Please select the Observation";
    }
    
    if (!values.question1) {
      errors.question1 = "Please select the question 1";
    }
    
    return errors;
  }, []);

  // Memoized validation status
  const isValid = useMemo(() => {
    return Object.keys(formValidation).length === 0;
  }, [formValidation]);

  return {
    formValidation,
    setFormValidation,
    checkValidation,
    isValid,
  };
};
